import React from 'react';
import { Wifi, WifiOff } from 'lucide-react';

/**
 * Connection Status Component
 * Displays the current connection status to the MQTT broker
 * 
 * @param {Object} props Component properties
 * @param {boolean} props.isConnected Whether connected to MQTT broker
 * @param {Date|null} props.lastMessage Timestamp of last received message
 */
const ConnectionStatus = ({ isConnected, lastMessage }) => {
  return (
    <div className="d-flex align-items-center">
      {isConnected ? (
        <span className="text-success d-flex align-items-center">
          <Wifi size={18} className="me-2" />
          Connected
        </span>
      ) : (
        <span className="text-danger d-flex align-items-center">
          <WifiOff size={18} className="me-2" />
          Disconnected
        </span>
      )}
      
      {lastMessage && (
        <span className="ms-3 text-muted small">
          Last message: {new Date(lastMessage).toLocaleTimeString()}
        </span>
      )}
    </div>
  );
};

export default ConnectionStatus;